(function($) {
	$(function () {
        
	})
})(window.jQuery)
